import React from "react";
import clsx from "clsx";

import TrainerIcon from "@material-ui/icons/Person";

import HighLightedItem from "../HighLightedItem";

import useStyles from "./styles";

interface IProps {
  value: string;
  searchValue: string;
}

const TrainerItem = (props: IProps) => {
  const { value, searchValue } = props;

  const classes = useStyles();

  return (
    <div className={classes.item}>
      <div className={classes.itemTrainerName}>
        <TrainerIcon
          className={clsx(classes.itemIcon, classes.itemTrainerIcon)}
        />
        <div className={classes.itemTrainerNameTitle}>
          <HighLightedItem value={value} searchValue={searchValue} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TrainerItem);
